import _ from 'lodash';
import React from 'react';
import ContentContainer from '~/src/components/ContentContainer';
import Markdown from '~/src/components/Markdown';
import { OtePlayer } from '~/src/models/OtePlayer';
import Picture from '~/src/overtime-lib/src/www/components/Picture';
import './Biography.scss';

const Biography = ({ player }: { player: OtePlayer }) => {
	return (
		<ContentContainer>
			<div className="PlayerProfileBiography">
				{player.hero_image_path ? (
					<div className="HeroContainer">
						<Picture
							mobileWidth={800}
							src={`https://images.overtime.tv/${player.hero_image_path}?quality=40`}
							alt={player.full_name}
						/>
					</div>
				) : null}
				{!_.isEmpty(player.biography) && (
					<div className="BiographyContainer">
						<h2>Biography</h2>
						<Markdown text={player.biography} />
					</div>
				)}
			</div>
		</ContentContainer>
	);
};

export default Biography;
